@if (canShowSupport()) {
  <button
    mat-fab
    appZendeskSupportToggle
    type="button"
    class="floating-support"
    data-cy="support-floating-button"
    matTooltip="Support"
    matTooltipPosition="right"
    [ngClass]="{ 'active': isSupportOpen() }"
  >
    <mat-icon
      class="sidebar-support"
      svgIcon="message-text"
      matBadgeSize="small"
      [matBadge]="supportUnreadCount()"
      [matBadgeHidden]="!supportUnreadCount()"
    />
  </button>
}
